import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';


import { HttpClient } from '@angular/common/http';

import { anyU } from 'src/app/models/anyU';
import { environment } from 'src/environments/environment';
declare var bootstrap: any;



@Component({
  selector: 'app-mythings',
  templateUrl: './mythings.component.html',
  styleUrls: ['./mythings.component.css']
})
export class MythingsComponent implements OnInit {

  baseUrl = environment.apiBaseUrl;
  @ViewChild('userModal') userModal: ElementRef | undefined;

  @ViewChild('detailModal') detailModal!: ElementRef;
  detailObj: any = null;
  searchText: string = '';
  filteredList: any[] = [];


  anyList: any[] = [];
  anyObj: any ={
      "id":0,
      "title":"",
      "text":"",

  }
  http = inject(HttpClient);

   ngOnInit(): void {
  this.getAllThing()
  }

  // constructor(private userService: Service) {}

  openModal(): void {
  // console.log("openModal triggered");
  if (this.userModal) {
    const modal = new bootstrap.Modal(this.userModal.nativeElement);
    modal.show();
  } else {
    // console.warn("userModal is undefined!");
  }
}


openDetailModal(item: any): void {
  this.detailObj = item;

  const modal = new bootstrap.Modal(this.detailModal.nativeElement);
  modal.show();
}


closeModal(): void {
  if (this.userModal) {
    const modal = bootstrap.Modal.getInstance(this.userModal.nativeElement);
    if (modal) modal.hide();
  }
}

  getAllThing(): void {
    this.http.get<anyU[]>(`${this.baseUrl}/mythings`).subscribe((res) => {
       // res آرایه‌ای است که از سرور می‌آید. با reverse ترتیب آن را برعکس می‌کنیم.
      // this.anyList = res.reverse();
      this.anyList = res;
      this.filteredList = res; // ← برای جستجو
      // console.log(this.anyList); // چاپ داده‌ها برای بررسی
    });
  }

  onSearch(): void {
  const text = this.searchText.toLowerCase().trim();
  this.filteredList = this.anyList.filter(item =>
    item.title.toLowerCase().includes(text) ||
    item.text.toLowerCase().includes(text)
  );
}



  onSave(): void {
  if (this.anyObj.id === 0) {
    // افزودن
    const newUser = { ...this.anyObj };
    delete newUser.id; // ← ID را حذف کن که نره به سرور
    this.http.post<anyU>(`${this.baseUrl}/mythings`, newUser).subscribe((res) => {
      this.getAllThing();
      this.closeModal();
    });
  } else {
    // ویرایش
    // this.http.put<anyU>(`${this.baseUrl}/mythings/${this.anyObj.id}`, this.anyObj).subscribe((res) => {
    this.http.post<anyU>(`${this.baseUrl}/mythings/update`, this.anyObj).subscribe((res) => {
      this.getAllThing();
      this.closeModal();
    });
  }
}


  // باز کردن مدال برای ویرایش
  openEditModal(user: any): void {
    this.anyObj = { ...user }; // پر کردن فیلدها با داده‌های کاربر انتخاب‌شده
    this.openModal();
  }

  // حذف کاربر
  delete(Id: number): void {
    if (confirm("آیا مطمئن هستید که می‌خواهید این کاربر را حذف کنید؟")) {
      // this.http.delete(`${this.baseUrl}/mythings/${Id}`).subscribe(() => {
        // this.http.post(`${this.baseUrl}/mythings/delete`, Id).subscribe(() => {
        this.http.post(`${this.baseUrl}/mythings/delete/${Id}`, null).subscribe(() => {

        this.getAllThing(); // بعد از حذف، لیست کاربران را مجدد بگیر
      });
    }
  }

}

